<dv_navbar></dv_navbar>
<div class="container-fluid">
  <div class="content">
      <router-outlet *ngIf="!isIframe"></router-outlet>
  </div>
</div>

<!-- Removed: <toaster-container> as ngx-toastr handles toast rendering automatically. -->

<div kendoDialogContainer></div>